// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3LvF8","inputWrap":"Table_inputWrap__1_1qV","col":"Table_col__bP4zn","bmiTooltip":"Table_bmiTooltip__3waMI"};